import React from 'react'

export default function Logo({ fill }) {
    return <svg/>
}